export const time = {
  state: {
    init: {
      description:
        'A time route is a circuit element that allows you to make call redirection conditions, depending on the specified time conditions. Depending on the fulfillment of the conditions, the call will be routed further along one of the routing scheme paths.'
    },
    add_schedule: {
      title: 'Choose a schedule',
      title_edit: 'Change Schedule',
      required: 'Schedule not selected'
    }
  }
};
